import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {AuditRefComponent} from "@webmate-web-core/shared/components/refs/audit-ref.component";
import {SpecRefComponent} from "@webmate-web-core/shared/components/refs/spec-ref.component";
import {ObservationTargetComponent} from "@webmate-web-core/shared/components/refs/observation-target.component";
import {Tooltip} from "primeng/tooltip";
import {Popover} from 'primeng/popover';
import {TagsModule} from '@webmate-web-core/shared/components/tags/tags.module';
import {FormsCommonsModule} from '@webmate-web-core/shared/components/forms-commons/forms-commons.module';
import {Button} from 'primeng/button';

@NgModule({
    declarations: [
        AuditRefComponent,
        ObservationTargetComponent,
        SpecRefComponent
    ],
    imports: [CommonModule, FontAwesomeModule, Tooltip, Popover, TagsModule, FormsCommonsModule, Button],
    exports: [
        AuditRefComponent,
        ObservationTargetComponent,
        SpecRefComponent
    ]
})
export class RefsSharedModule {
}
